export const ParentLinkId = "parentLinkId";
export const ParentLinkIdsArray = "parentLinkIdsArray";
export const ComponentOrder = "componentOrder";
export const OnScreenText = "onScreenText";
export const FieldMapping = "fieldMapping";
export const FieldMappingId = "fieldMappingId";
export const DropdownOptions = "dropdownOptions";
export const SavedDropDownOptions = "savedDropDownOptions";
export const BusinessText = "businessText";
export const DepotText = "depotText";
export const LevelThreeText = "levelThreeText";
export const LevelFourText = "levelFourText";
export const UseDepot = "useDepot";
export const UseLevelThree = "useLevelThree";
export const UseLevelFour = "useLevelFour";
export const UseTodaysDate = "useTodaysDate";
export const IsParentControl = "isParentControl";
export const ShowChildControlAsDisabled = "showChildControlAsDisabled";
export const IsEnol = "isEnol";
export const IsMandatory = "isMandatory";
export const FieldValidationId = "fieldValidationId";
export const ShowLatLong = "showLatLong";
export const ShowOpenStreetMap = "showMap";
export const ShowInfoIcon = "showInfoIcon";
export const InfoIconText = "infoIconText";
export const EnolFieldMappingArray = "enolFieldMappingArray";
export const Name = "name";
export const FilteredChildDropdownOptions = "filteredChildDropdownOptions";
export const CustomerBusinessHierarchy = "customerBusinessHierarchy";
export const UseUpdatedControl = "useUpdatedControl";
export const Visibility = "visibility";
export const PreventFutureDatesAndTimes = "preventFutureDatesAndTimes";
export const AutoPopulationOptionsHidden = "autoPopulationOptionsHidden";
export const MaxReportingDelay = "maxReportingDelay";
